import React, { useEffect, useState } from 'react';
import { EditOrder } from 'pages/Order/components';
import { useSelector } from 'react-redux';
import {
  ordersIdsSelector,
  ordersEntitiesSelector,
  isLoadingOrdersSelector,
  getOrderAction,
} from 'state/slices/order';
import { useDispatch } from 'hooks/store';
import { Skeleton } from 'antd';
import SectionBasePage from 'components/SectionBasePage';
import { useOrganizationContext } from 'hooks/contextOrganization';

import {
  LoadingContainer,
} from './style';

interface CreateOrderPageProps {
  onOrderCopy: () => string | undefined,
  orderToCopy?: string,
}

const CreateOrderPage = ({
  orderToCopy,
  onOrderCopy,
}: CreateOrderPageProps): JSX.Element => {
  const dispatch = useDispatch();
  const [internalOrderToCopy, setInternalOrderToCopy] = useState<string | undefined>();

  const orderId = useSelector(ordersIdsSelector)
    .find((curOrderId) => `${curOrderId}` === internalOrderToCopy) || '';
  const orderEntities = useSelector(ordersEntitiesSelector);
  const order = orderEntities[orderId];

  const isOrderLoading = useSelector(isLoadingOrdersSelector);

  useEffect(() => {
    if (orderToCopy) {
      dispatch(getOrderAction({
        orderId: orderToCopy,
      }));
      setInternalOrderToCopy(orderToCopy);
    }
  }, [orderToCopy]);

  useEffect(() => () => {
    onOrderCopy();
  }, []);

  const organizationContext = useOrganizationContext();

  return (
    <>
      {
        isOrderLoading || organizationContext.organization === undefined ? (
          <SectionBasePage>
            <LoadingContainer>
              <Skeleton />
            </LoadingContainer>
          </SectionBasePage>
        ) : (
          <EditOrder
            activeOrder={order}
            isCopy={!!internalOrderToCopy}
            selectedOrg={organizationContext.organization}
          />
        )
      }
    </>
  );
};

export default CreateOrderPage;
